module.exports = __webpack_public_path__ + "static/media/Dragon-Defeat.308e1b3b.gif";